import { Fragment, lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { RoutesProps } from 'types';

import { formatRoutesToArr } from './formatRoutesToArr';

export default function getLazyRoutes(routes: RoutesProps, loggedIn: boolean) {
  const routesArr = formatRoutesToArr(routes).map(
    ({
      dirName,
      root: {
        path,
        id,
        title,
        isProtected,
        module: configModule,
        component: { props },
      },
      ...nested
    }) => {
      const Component = lazy(() =>
        import(`modules/${configModule}/pages/${dirName}`).then((module) => ({ default: module[dirName] })),
      );
      const hasNestedRoutes = Object.keys(nested).length;

      const routerRouteJsx = (
        <Route
          path={path}
          element={isProtected && !loggedIn ? <Navigate to="/404" /> : <Component title={title} {...props} />}
          key={id}
        />
      );

      if (hasNestedRoutes) {
        return (
          <Fragment key={id}>
            {getLazyRoutes(nested, loggedIn)}
            {routerRouteJsx}
          </Fragment>
        );
      }
      return routerRouteJsx;
    },
  );
  return routesArr.flat();
}
